import React, { memo } from "react";
import { Map, TileLayer, GeoJSON, LayersControl, LayerGroup } from "react-leaflet";
import "react-leaflet-fullscreen/dist";
import "react-leaflet-fullscreen/dist/styles.css";
import MapCache from "../../../../components/MapCache";
import "./style.scss";

const OperationMap = memo(({ featureCollection, carLayers, ...props }) => {
	const features = featureCollection.features.map(feature => feature);
	const onlyXY = features.map(feature => {
		return feature.geometry.coordinates[0].map(coord => {
			return coord.filter((_, index) => index !== 2);
		})
	}).flat(1);

	const bounds = onlyXY.map(coord =>
    [...coord].reverse()
  );

  return (
    <>
      <Map
        fullscreenControl
        center={onlyXY[0]}
				zoom={15}
        bounds={bounds}
        // maxBounds={bounds}
        {...props}
      >
        <LayersControl position="topright">
          <LayersControl.BaseLayer checked name="Google Satellite">
            <TileLayer
              url="http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
              minZoom="10"
              subdomains={['mt0','mt1','mt2','mt3']}
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="Open Street Map">
            <TileLayer
              attribution='&amp;copy <a href="https://www.openstreetmap.org/about">OpenStreetMap</a>'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              minZoom="10"
            />
          </LayersControl.BaseLayer>
        </LayersControl>

        <MapCache />

				{features.map((feature, index) => (
					<GeoJSON
						key={`${index}`}
						data={feature.geometry}
						style={{
              color: '#13FFE8',
              fillColor: 'rgba(0, 0, 0, 0)',
              fillOpacity: 0 
            }}
					/>
				))}
        {carLayers.length > 0 && (
          <LayersControl position="topright">
            {carLayers.map((car) =>
              car.layers.map((camada, camadaIndex) => (
                <LayersControl.Overlay
                  key={`${car.id}-${camadaIndex}`}
                  name={`${car.numero} - ${camada.name} `}
                >
                  <LayerGroup>
                    {Array.isArray(camada.layer.features) && camada.layer.features.length > 0 && (
                      <GeoJSON
                        data={camada.layer}
                        style={camada.style}
                      />
                    )}
                  </LayerGroup>
                </LayersControl.Overlay>
              ))
            )}
          </LayersControl>
        )}

      </Map>
    </>
  );
});

export default OperationMap;
